import { render, staticRenderFns } from "./JwtAuthorize.vue?vue&type=template&id=47cef84e&scoped=true"
import script from "./JwtAuthorize.vue?vue&type=script&lang=js"
export * from "./JwtAuthorize.vue?vue&type=script&lang=js"
import style0 from "./JwtAuthorize.vue?vue&type=style&index=0&id=47cef84e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cef84e",
  null
  
)

export default component.exports